import { Link } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import Dialog from "../../../components/Dialog";
import { DialogItem } from "../../../components/Dialog/types";
import { TableData } from "../../../components/Table/types";
import { Schema } from "../../../api/types";
import { EntityId, Update } from "../../../hooks/useEntitySelection";
import { timeToText } from "../../../utils/time";
import { typedSxMap } from "../../../utils/typedSxMap";

const styles = typedSxMap({
  tableName: {
    display: "flex",
    alignItems: "center",
    gap: "var(--m-xs)",
    "&>a": {
      textDecoration: "none",
    },
  },
});

export function schemasTable(schemas: Schema[] = [], update: Update): TableData {
  const actionMenu: DialogItem[] = [
    { children: "Edit", action: (id: EntityId) => update(id, "edit") },
    { children: "Delete", action: (id: EntityId) => update(id, "delete") },
  ];

  return schemas.map((schema) => {
    return {
      id: schema.id,
      Name: {
        raw: schema.name,
        content: (
          <Box sx={styles.tableName}>
            <Link to={`/schema/${schema.id}`}>{schema.name}</Link>
          </Box>
        ),
      },
      Columns: schema.schema_columns?.length,
      Created: timeToText(schema.created_at),
      _actions: {
        raw: schema.id,
        content: <Dialog items={actionMenu.map((e) => ({ ...e, id: schema.id }))} />,
      },
    };
  });
}
